// Hero Slider Component for ApolloRims
class HeroSlider {
  constructor(element, options = {}) {
    this.slider = element;
    this.slides = element.querySelectorAll('.slider-slide');
    this.currentSlide = 0;
    this.autoPlayInterval = options.autoPlayInterval || 5000;
    this.autoPlayTimer = null;
    this.isTransitioning = false;
    
    if (this.slides.length > 0) {
      this.init();
    }
  }

  init() {
    this.createNavigation();
    this.createDots();
    this.showSlide(0);
    this.startAutoPlay();
    this.addEventListeners();
  }

  createNavigation() {
    // Create previous button
    const prevBtn = document.createElement('button');
    prevBtn.className = 'slider-nav slider-nav-prev';
    prevBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    prevBtn.setAttribute('aria-label', 'Previous slide');
    
    // Create next button
    const nextBtn = document.createElement('button');
    nextBtn.className = 'slider-nav slider-nav-next';
    nextBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    nextBtn.setAttribute('aria-label', 'Next slide');
    
    this.slider.appendChild(prevBtn);
    this.slider.appendChild(nextBtn);
    
    prevBtn.addEventListener('click', () => this.prev());
    nextBtn.addEventListener('click', () => this.next());
  }

  createDots() {
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'slider-dots';
    
    this.slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.className = 'slider-dot';
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      dot.addEventListener('click', () => this.goToSlide(index));
      dotsContainer.appendChild(dot);
    });
    
    this.slider.appendChild(dotsContainer);
    this.dots = dotsContainer.querySelectorAll('.slider-dot');
  }

  showSlide(index) {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    
    // Update slides
    this.slides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });
    
    // Update dots
    if (this.dots) {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
    }
    
    this.currentSlide = index;
    
    // Reset transitioning flag after animation
    setTimeout(() => {
      this.isTransitioning = false;
    }, 600);
  }

  next() {
    const nextIndex = (this.currentSlide + 1) % this.slides.length;
    this.showSlide(nextIndex);
    this.resetAutoPlay();
  }

  prev() {
    const prevIndex = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.showSlide(prevIndex);
    this.resetAutoPlay();
  }

  goToSlide(index) {
    this.showSlide(index);
    this.resetAutoPlay();
  }

  startAutoPlay() {
    this.autoPlayTimer = setInterval(() => this.next(), this.autoPlayInterval);
  }

  stopAutoPlay() {
    if (this.autoPlayTimer) {
      clearInterval(this.autoPlayTimer);
      this.autoPlayTimer = null;
    }
  }

  resetAutoPlay() {
    this.stopAutoPlay();
    this.startAutoPlay();
  }

  addEventListeners() {
    // Pause on hover
    this.slider.addEventListener('mouseenter', () => this.stopAutoPlay());
    this.slider.addEventListener('mouseleave', () => this.startAutoPlay());
    
    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.prev();
      if (e.key === 'ArrowRight') this.next();
    });
  }

  destroy() {
    this.stopAutoPlay();
  }
}

// Initialize all sliders on page load
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.hero-slider');
  sliders.forEach(slider => {
    new HeroSlider(slider);
  });
});
